import React from 'react';
import { StepsBannerArrows } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import '../updateContactDetails.scss';
import UpdateContact from '../../../components/updateContact/updateContact';
import VerifyCode from '../../../components/verifyCode/verifyCode';
import { FORM_KEYS } from '../../../constants/formKeys';
import { SuccessMessageDialog } from '../../../components/successMessage/successMessageDialog';
import useUpdateEmail from './useUpdateEmail';
import Loading from '../../../components/shared/Loading/Loading';

const UpdateEmail = () => {
  const {
    steps,
    isUpdateEmailStep,
    onUpdateClick,
    onCancelClick,
    validation,
    newEmailValue,
    contactDetailsLoading,
    errorMessage,
    isCodeVerified,
    getVerifyCode,
    isCodeSent,
    confirmUserEnrollment,
    timeLeft,
    onSuccessModalContinueClicked
  } = useUpdateEmail();

  return (
    <div className="updateContactDetailsContainer">
      <StepsBannerArrows steps={steps} />
      {contactDetailsLoading && <Loading />}
      {isUpdateEmailStep && (
        <UpdateContact
          title="Update email"
          inputLabel="New email"
          inputPlaceholder="Enter new email"
          inputName={FORM_KEYS.NEW_EMAIL}
          onUpdateClick={onUpdateClick}
          onCancelClick={onCancelClick}
          validation={validation}
          updateButtonLabel="Update email"
          errorMessage={errorMessage && errorMessage}
        />
      )}
      {/* Verify new email */}
      {!isUpdateEmailStep && !isCodeVerified && (
        <VerifyCode
          type="email"
          typeValue={newEmailValue}
          title="Verify your email"
          handleSendCode={getVerifyCode}
          handleVerifyCode={confirmUserEnrollment}
          isCodeSent={isCodeSent}
          errorMessage={errorMessage}
          timeLeft={timeLeft}
        />
      )}
      {isCodeVerified && (
        <SuccessMessageDialog
          message="Thank you - Your request to change your email address has been received. Please note that it might take a few minutes for your new email address to take effect."
          closeButtonLabel="Continue"
          onClose={onSuccessModalContinueClicked}
        />
      )}
    </div>
  );
};

export default UpdateEmail;
